<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="layout--main" :class="[navbarClasses, footerClasses, {'app-page': isAppPage}]">

        <vx-sidebar  :logo="require('@/assets/images/logo/logo_menu.png')" title="Satsanga" parent=".layout--main"> 
        </vx-sidebar>

        <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
            <div id="content-overlay"></div>

            <div class="content-wrapper">
                <the-navbar 
                    :navbarColor="navbarColor" 
                    v-on:spaListSelect="updateSpaListSelect" 
                    v-bind:SpaListNavbar="SpaListNavbar"
                    v-bind:spaTemp="spaTemp"
                    v-on:spaChanged="updateSchedule"
                    v-on:hotelChanged="updateHotel"
                    v-on:loadScheduler="loadScheduler"  
                    v-on:loadInitialHotel="loadInitialHotel" 
                    :class="[{'text-white': isNavbarDark && !isThemeDark}, 
                    {'text-base': !isNavbarDark && isThemeDark}]"
                    :listUpdatedSpas="listUpdatedSpas" 
                />

                <div class="router-view">
                    <div class="router-content" :class="{'mt-0': navbarType == 'hidden'}">
                        <transition :name="routerTransition">
                        <div class="router-header flex flex-wrap items-center mb-6" v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
                            <div class="content-area__heading" :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}">
                                <h2 class="mb-1">{{ routeTitle }}</h2>
                            </div>

                            <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" />

                            <vs-dropdown class="ml-auto md:block hidden cursor-pointer" vs-trigger-click>
                                <vs-button radius icon="icon-settings" icon-pack="feather"></vs-button>

                                <vs-dropdown-menu class="w-32">

                                    <vs-dropdown-item>
                                      <div @click="$router.push('/pages/profile')" class="flex items-center">
                                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                        <span>Profile</span>
                                      </div>
                                    </vs-dropdown-item>

                                    <vs-dropdown-item>
                                      <div @click="$router.push('/apps/todo')" class="flex items-center">
                                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                        <span>Tasks</span>
                                      </div>
                                    </vs-dropdown-item>

                                    <vs-dropdown-item>
                                      <div @click="$router.push('/apps/email')" class="flex items-center">
                                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                        <span>Inbox</span>
                                      </div>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
                        </transition>
                        <div class="content-area__content">
                            <back-to-top bottom="5%" visibleoffset="500" v-if="!hideScrollToTop">
                                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg" />
                            </back-to-top>
                            <transition :name="routerTransition" mode="out-in">
                                <router-view
                                    v-on:spaListSelect="updateSpaListSelect" 
                                    v-on:loadSchedulerSpaTemp="loadSchedulerSpaTemp"  
                                    v-on:loadInitialHotel="loadInitialHotel" 
                                    :SpaListNavbar="SpaListNavbar"
                                    :spaSelected="spaSelected" 
                                    :spaInitial="spaInitial"
                                    :hotelSelected="hotelSelected"
                                    @changeRouteTitle="changeRouteTitle"
                                    @updateSpaList="updateSpaList"
                                >
                                </router-view>
                            </transition>
                        </div>
                    </div>
                </div>

            </div>

            <the-footer></the-footer>
        </div>
    </div>
</template>

<script>
import VxSidebar from '@/layouts/components/vx-sidebar/VxSidebar.vue';
import TheNavbar from '../components/TheNavbar.vue';
import TheFooter from '../components/TheFooter.vue';
import themeConfig from '@/../themeConfig.js';
import BackToTop from 'vue-backtotop'

import moment from 'moment';

export default {
    props: [
        'hoteisvg'
    ],
    data() {
        return {
            navbarType: themeConfig.navbarType || 'floating',
            navbarColor: themeConfig.navbarColor || '#fff',
            footerType: themeConfig.footerType || 'static',
            routerTransition: themeConfig.routerTransition || 'none',
            isNavbarDark: false,
            routeTitle: this.$route.meta.pageTitle,
            disableCustomizer: themeConfig.disableCustomizer,
            windowWidth: window.innerWidth, 
            hideScrollToTop: themeConfig.hideScrollToTop,
            disableThemeTour: themeConfig.disableThemeTour,
            SpaListNavbar: [],
            spaSelected: null,
            spaInitial: null,
            hotelSelected: '',
            listUpdatedSpas: [],
            spaTemp: null,
        }
    },

    watch: {
        '$route'() {
            this.routeTitle = this.$route.meta.pageTitle;
        },

        isThemeDark(val) {
            if(this.navbarColor == "#fff" && val) {
                this.updateNavbarColor("#10163a")
            }else {
                this.updateNavbarColor("#fff")
            }
        },
    },

    computed: {
        isAppPage() {
            if(this.$route.path.includes('/apps/')) 
                return true
            return false
        },

        isThemeDark() { 
            return this.$store.state.theme == 'dark' 
        },

        sidebarWidth() {
            return this.$store.state.sidebarWidth;
        },

        bodyOverlay() {
            return this.$store.state.bodyOverlay;
        },

        contentAreaClass() {
            if(this.sidebarWidth == "default") return "content-area-default"
            else if(this.sidebarWidth == "reduced") return "content-area-reduced"
            else if(this.sidebarWidth) return "content-area-full"
        },

        navbarClasses() {
            return {
                'navbar-hidden': this.navbarType == 'hidden',
                'navbar-sticky': this.navbarType == 'sticky',
                'navbar-static': this.navbarType == 'static',
                'navbar-floating': this.navbarType == 'floating',
            }
        },

        footerClasses() {
            return {
                'footer-hidden': this.footerType == 'hidden',
                'footer-sticky': this.footerType == 'sticky',
                'footer-static': this.footerType == 'static',
            }
        },

        isloggedIn() {
            return this.$store.state.loggedIn; 
        },
    },

    methods: {
        updateSpaList(data){
            this.listUpdatedSpas = data;
        },

        changeRouteTitle(title) {
            this.routeTitle = title;
        },
        updateNavbarColor(val) {
            this.navbarColor = val;
            if(val == "#fff") this.isNavbarDark = false
            else this.isNavbarDark = true
        },
        handleWindowResize(event) {
            this.windowWidth = event.currentTarget.innerWidth;
            this.setSidebarWidth();
        },
        setSidebarWidth() {
            if (this.windowWidth < 1200) {
                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false);
                this.$store.dispatch('updateSidebarWidth', 'no-sidebar');
                this.disableThemeTour = true;
            }else {
                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
            }
        },
        toggleHideScrollToTop(val) {
            this.hideScrollToTop = val;
        },

        updateSpaListSelect(input){
            this.SpaListNavbar = input;
        },

        updateSchedule(input){
            this.spaSelected = input;
        },

        updateHotel(input) {
            this.hotelSelected = input;
        },
        
        loadScheduler(input){
            this.spaInitial = input;
        },

        loadSchedulerSpaTemp(input){
            this.spaTemp = input;
        },

        loadInitialHotel(input)
        {  
            this.hotelSelected = input;
        },

        logout(){
          window.localStorage.removeItem('usertoken');    
          window.localStorage.removeItem('userSession');    

          window.localStorage.clear();

          this.$store.dispatch('removeSelectedSpa');

          this.$router.push('/login');  
        }
    },
    components: {
        VxSidebar,
        TheNavbar,
        TheFooter,
        BackToTop,
    },

    created() {
        this.setSidebarWidth();
        
        if(this.navbarColor == "#fff" && this.isThemeDark) {
            this.updateNavbarColor("#10163a")
        }else {
            this.updateNavbarColor(this.navbarColor)
        }                                
    },

    beforeUpdate() {
        let session = JSON.parse(window.localStorage.getItem('userSession')); 

        let current_time = moment().format('YYYY-MM-DD HH-mm-ss');

        let time_diff = moment.utc(moment(current_time,"YYYY-MM-DD HH-mm-ss").diff(moment(session.login_date,"YYYY-MM-DD HH-mm-ss"))).format("HH:mm:ss");

        if(time_diff.substring(0,2) >= 4) 
        {
            this.logout();
        }
    },

}
</script>

<style>
    @import '../../assets/css/font-awesome4.7.0.min.css';
</style>
